import type { FaireProductEntity } from "../../entity_types/product";

export const p_atnp4dyxjh: FaireProductEntity = {
  token: "p_atnp4dyxjh",
  type: "product",
  name: "Wholesale Retail-Ready Candles – Pre-Labeled & Handcrafted",
  brandToken: "b_8m9j47nd48",
  brandName: "Candle Bliss",
  imageUrl:
    "https://cdn.faire.com/fastly/66db41cfe536fb81d60b1d1485b62f138f89a831c2eb70273e1b19e66820646d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c3fcec3133dec5faf55df33fc25c6ec9a63eb1028fd1f48338e08474c29cb46f.jpeg",
    "https://cdn.faire.com/fastly/4ea648982cf3fd5ac7338105df5cdb2c5603facb4fb7e5952506508d9287cd83.jpeg",
    "https://cdn.faire.com/fastly/dbc2bd9398e788b21c21a272bc179711e86ff7b1759f79f37917ac57732eb26e.jpeg",
    "https://cdn.faire.com/fastly/7571b6293944a2e946fdbb2173c7a2015c07f599be1f3ce568e14f91fcdb20da.jpeg",
    "https://cdn.faire.com/fastly/97df9957f4b84023fd3a5f4df8f63badffa150228ae27cf8ce5070af22e53a2d.jpeg",
    "https://cdn.faire.com/fastly/60ebfd283c8ee8b99b73d7295ab8763d46c6fe6b98f0378dffda09391ab0617d.jpeg",
    "https://cdn.faire.com/fastly/c2e626e44f6de2fda628dfee6d616ef3e575f85a24f8e2f92c5607b5dd7ff43c.jpeg",
  ],
  priceDollars: 6.5,
  description:
    "Create Your Own Candle Line with Ease\nWant to launch your own candle business without the hassle? Our hand-poured, white-label natural Apricot Coconut wax candles make it simple to add a beautifully crafted product to your brand.\n\nCustom Branding Made Simple\nAt Candle Bliss, we believe in the power of personalization. Each candle serves as a blank canvas for your creativity, allowing you to showcase your brand with a custom-designed label.\n\nHow It Works:\n1. Choose your fragrance\n2. Select your candle size\n3. Select Customize this Item: Enter your Company Name\n3. Place your order\n\nCustom Label Artwork Guidelines:\nSmall (4oz): 624 x 546 px (RGB, JPEG)\nLarge (9oz): 864 x 705 px (RGB, JPEG)\n\nHave a custom design? After check out, send us your label design in the Custom Label Artwork Guidelines listed above. \n\nHow to Burn A Candle Safely, View: https://candles.org/fire-safety-candles/\n\n-Never leave a burning candle unattended.\n-Never burn a candle on or near anything that might catch fire.\n-Keep candles out of the reach of children and pets.",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:45.393Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
